import {api} from "./axios"
export function getProfileApi() {
    return api.get(`affiliate-partners/my-info`)
}
export function updateProfileApi(data) {
    return api.put(`affiliate-partners/my-info`, data)
}
export function updateAvatarApi(data) {
    return api.post(`affiliate-partners/my-info/avatar/update `, data)
}

export function deleteAvatarApi() {
    return api.delete(`/profile/avatar/remove`)
}

export function getCountriesApi() {
    return api.get(`/en/profile/location/country`)
}

export function changePasswordApi(data) {
    return api.put(`affiliate-partners/my-info/update-password`, data)
}

export function getBalanceApi() {
    return api.get(`/user/balance`)
}
export function getUserManagerApi(params) {
    return api.get(`/admin-contacts`, {params})
}
export function getConditionsApi() {
    return api.get(`affiliate-partners/my-info/programs`)
}

export function getReferralLinkApi() {
    return api.get(`/affiliate-partners/my-info/referral-link`)
}

export function getApiTokenApi() {
    return api.get(`affiliate-partners/api-token`)
}

export function createOrRefreshApiTokenApi() {
    return api.post(`affiliate-partners/api-token`)
}

export function deleteApiTokenApi() {
    return api.delete(`affiliate-partners/api-token`)
}
